import '@ventionco/vention_fonts/icomoon/style.css';
import '@ventionco/vention_fonts/fontawesome/style.css';
import '@ventionco/vention_fonts/larsseit/style.css';

/**
 * @deprecated You should not be writing CSS-in-JS anymore, use CSS3 variables in CSS files instead.
 */
const cssColors = {
  light_grey: '#F2F2F2',
  blueish_grey: '#c1c4ca',
  slider_grey: '#666',
  grey: '#ccc',
  orange: '#FF8000',
  border_color: '#CFCFCF',
  active_tab_color: '#EFF2F7',

  vention_blue: '#1C344F',
  bright_blue: '#027BE7',
  blue_grey: '#334257',
  line_grey: '#EEF1F5',
  border_grey: '#EFF2F7',
  green: '#1AC776',
  light_green: '#1ADC76',
  pale_green: '#E2F0D9',
  dark_green: '#0D261A',
  red: '#800000',
  pale_red: '#f8dbdb',
  pale_orange: '#ffeded',
  switch_off: '#ccc',
  switch_on: '#2196F3',
  scrollbar: '#D4D7DD',
  pale_yellow: '#FEFFEF',
  yellow: '#FEFFC4',
};

function messageBox (pMessage, pLevel = 'info', options = {}) {
  if (undefined != window.toastr) {
    if (undefined == window.toastr.options || Object.keys(window.toastr.options).length == 0) {
      window.toastr.options = {
        closeButton: true,
        positionClass: 'toast-top-center',
        preventDuplicates: true,
      };
    }

    switch (pLevel) {
      // follow this window.toastr.type(message, title, option)
      case undefined:
      case 'info': window.toastr.info(pMessage, '', options); break;
      case 'warning': window.toastr.warning(pMessage, '', options); break;
      case 'error': window.toastr.error(pMessage, '', options); break;
      case 'success': window.toastr.success(pMessage, '', options); break;
    }
  }
  else {
    alert(pMessage + (undefined != pLevel ? (' [' + pLevel + ']') : ''));
  }
}

/**
 * @deprecated You should not be writing CSS-in-JS anymore, use CSS files instead.
 */
function defineCssRule (pName, pRule) {
  let lS = document.getElementById('pendant-style');
  let lBasis;
  if (!lS) {
    lS = document.createElement('style');
    lS.type = 'text/css';
    lS.id = 'pendant-style';
    document.getElementsByTagName('head')[0].appendChild(lS);
  }
  lBasis = (lS.sheet || {});
  if (lBasis.insertRule) {
    if (typeof pRule == 'string') {
      lBasis.insertRule(pName + ' {' + pRule + '}', 0);
    }
    else {
      // just to give the ability to do _define('.test', { border: '1px red solid', border-radius: '1px' })
      pRule && lBasis.insertRule(pName + ' ' + JSON.stringify(pRule).replace(/,/ig, ';').replace(/"/ig, ''));
    }
  }
  else {
    lBasis = (lS.styleSheet || lS.sheet);
    if (lBasis.addRule) {
      lBasis.addRule(pName, pRule);
    }
    else {
      console.log('FATAL: defineCssRule');
    }
  }
}

/**
 * @deprecated You should not be writing CSS-in-JS anymore, use CSS3 variables in CSS files instead.
 */
const defineCss = defineCssRule;

export {
  defineCss,
  cssColors,
  messageBox,
};

// TODO GD Used in VSE, get rid of it
window._style = {
  messageBox,
};
